// Helpers condivisi per la pagina Menu
import { Percent } from "lucide-react";

export const formatEuro = (val) => {
  if (val === null || val === undefined) return "—";
  return `€ ${Number(val).toFixed(2)}`;
};

export const formatPercentuale = (val) => {
  if (val === null || val === undefined) return "—";
  return `${Number(val).toFixed(1)}%`;
};

export const MargineBadge = ({ margine }) => {
  if (margine === null || margine === undefined) return null;

  let color = "bg-red-100 text-red-700";
  if (margine >= 70) color = "bg-green-100 text-green-700";
  else if (margine >= 50) color = "bg-emerald-100 text-emerald-700";
  else if (margine >= 30) color = "bg-yellow-100 text-yellow-700";
  else if (margine >= 15) color = "bg-orange-100 text-orange-700";

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${color}`}>
      <Percent className="w-3 h-3" />
      {formatPercentuale(margine)}
    </span>
  );
};

export const crownRank = (rank) => (rank === 1 ? "👑" : rank === 2 ? "🥈" : "🥉");
